import { createStateHook } from 'react-sweet-state';

// @ts-expect-error - CustomerStore has no TypeScript declarations
import { CustomerStore } from './CustomerStore';

// The store sets this id before the customer data loads. A reviewer never loads a customer,
// so `useCurrentCustomerId()` stays empty for a reviewer.
export const useSelectedCustomerId = createStateHook(CustomerStore, {
  selector: (state: { currentCustomerId?: string | number | null }): string | null =>
    state.currentCustomerId ? String(state.currentCustomerId) : null,
});
